module.exports = __webpack_public_path__ + "static/media/Deluxe.8e0cd667.jpg";